/* eslint-disable @next/next/no-img-element */
import { observer } from "mobx-react"
import { BreakPoints } from "styles/styles"
import { useStore } from "@features/common"
import { CtaButton } from "@ui"
import parse from "react-html-parser"
import { useEffect, useState } from "react"

import AceOfSpades from "./ace-of-spades.png"
import CreaturesSixtyNining from "./creatures-sixty-nining.png"
import CreaturesSixtyNiningMobile from "./creatures-sixty-nining-mobile.png"
import NewsAndJoinBg from "./news-and-join-bg.svg"

const NewsAndJoin = () => {
  const {
    ResponsiveModel: { width },
    GlobalModel: { lang },
    TeamPageModel: { getTemplate },
  } = useStore()
  const isLessThanDesktop = width > 0 && width < BreakPoints.tablet_lg

  const [rotation, setRotation] = useState(-2)

  useEffect(() => {
    if (isLessThanDesktop) {
      setRotation(-2)
    } else {
      setRotation(2)
    }
  }, [isLessThanDesktop])

  const newsTitle = parse(getTemplate("about.news.title", false) || "Pure News")
  const newsDescription =
    getTemplate("about.news.description") ||
    "Stories, features, and product updates from the world of Pure"
  const newsCta = getTemplate("about.news.cta") || "visit our newsroom"
  const newsCtaLink = getTemplate("about.news.ctaLink") || "careers"

  const joinTitle = parse(
    getTemplate("about.join.title", false) || "Join the Pure<br/>team",
  )
  const joinDescription =
    getTemplate("about.join.description") ||
    "We’re always looking for people to help us make dating more playful."
  const joinCta = getTemplate("about.join.cta") || "explore open roles"
  const joinCtaLink = getTemplate("about.join.ctaLink") || "careers"
  const joinPrivacy = parse(
    getTemplate("about.join.privacy", false) ||
      `We process applicant data as described in our <a class="underline" href="/${lang}/gdpr">privacy policy for job applications.</a>`,
  )

  return (
    <section className="relative w-full">
      <div className="w-full max-w-screen-desktop-l mx-auto pt-[90px] tablet-lg:pt-[158px] pb-0 tablet-lg:pb-[65px] px-0 tablet-lg:px-[50px] flex justify-center flex-col-reverse tablet-lg:flex-row gap-[50px] tablet-lg:gap-[150px]">
        <NewsAndJoinBg
          viewBox="0 0 1440 896"
          className="hidden tablet-lg:block absolute top-0 left-0 w-full h-full -z-1 pointer-events-none select-none"
        />
        <div className="w-full tablet-lg:w-[400px] relative flex flex-col items-center pb-[50px] laptop:pb-0">
          <NewsAndJoinBg
            viewBox="0 0 1440 896"
            className="block tablet-lg:hidden absolute top-0 left-0 w-full h-full -z-1 pointer-events-none select-none"
          />
          <img
            src={AceOfSpades.src}
            alt="Ace of Spades"
            className="h-[200px] laptop:h-[250px] mt-0 laptop:mt-[-50px] mb-[40px]"
          />
          <div className="tablet-lg:px-0 px-[38px] flex flex-col items-center">
            <h3 className="font-pure text-center rotate-[-2deg] mb-[35px] laptop:mb-[50px] leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px]">
              {newsTitle}
            </h3>
            <p className="rotate-[2.888deg] laptop:ml-[70px] mb-[35px] laptop:mb-[50px] font-sans text-[16px] leading-[20px] laptop:text-[20px] laptop:leading-[32px]">
              {newsDescription}
            </p>
            <a href={newsCtaLink} target="_blank" rel="noopener noreferrer">
              <CtaButton text={newsCta} rotation={rotation} />
            </a>
          </div>
        </div>

        <div className="w-full tablet-lg:w-[400px] relative flex flex-col items-center pb-[50px] laptop:pb-0">
          <img
            src={CreaturesSixtyNiningMobile.src}
            className="block tablet-lg:hidden relative mb-[30px] laptop:mb-0 w-[130%] tablet-s:w-full h-auto mt-[-50px] left-[-20px] tablet-s:left-0 max-w-[545px] tablet-s:max-w-none tablet-lg:w-[373px]"
            alt="Creatures Sixty Nining"
          />
          <img
            src={CreaturesSixtyNining.src}
            className="hidden tablet-lg:block relative mb-[30px] laptop:mb-0 w-[130%] tablet-s:w-full h-auto mt-[-50px] left-[-20px] tablet-s:left-0 max-w-[545px] tablet-s:max-w-none tablet-lg:w-[373px]"
            alt="Creatures Sixty Nining"
          />
          <div className="tablet-lg:px-0 px-[20px] flex flex-col items-center">
            <h3 className="w-fit absolute top-[-40px] right-[55px] tablet-lg:right-auto text-right tablet-lg:text-center tablet-lg:relative font-pure leading-[48px] tablet:leading-[64px] text-[36px] tablet:text-[64px] rotate-[-2deg]">
              {joinTitle}
            </h3>
            <p className="px-[20px] laptop:px-0 mb-[44px] laptop:ml-[50px] font-sans text-[16px] leading-[20px] laptop:text-[20px] laptop:leading-[32px] rotate-[1.849deg] ">
              {joinDescription}
            </p>
            <a href={joinCtaLink} target="_blank" rel="noopener noreferrer">
              <CtaButton text={joinCta} rotation={-3} />
            </a>
            <p className="px-[20px] mt-[30px] font-sans-bold text-black/30 leading-[18px] laptop:leading-[17px] text-[9px] laptop:text-[11px] text-center">
              {joinPrivacy}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

const NewsAndJoinComponent = observer(NewsAndJoin)
export { NewsAndJoinComponent }
